var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"applying banner"},[_c('div',{staticClass:"thank"},[_c('img',{attrs:{"src":require("@/assets/img/10.png"),"alt":""}}),_vm._m(0),_c('el-button',{attrs:{"round":""},on:{"click":_vm.handkeGoChu}},[_vm._v("返回首页")])],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tip"},[_c('span',[_vm._v("已收到您的申请，请耐心等待审核通过~")])])
}]

export { render, staticRenderFns }